/**
 * Background music toggle.
 *
 * Expects:
 *   <audio id="bg-music" loop data-src="/assets/audio/background.mp3"></audio>
 *   <button class="music-toggle" ...>   (may appear more than once, e.g. header + Me hub)
 *
 * Music never autoplays — it plays only when the user presses a toggle.
 * The audio file is fetched lazily on the first play.
 * Toggles are hidden automatically if the audio file fails to load.
 * All toggles stay in sync.
 */
(function () {
  const audio = document.getElementById('bg-music');
  if (!audio) return;

  // Query live so toggles added later (e.g. via SPA navigation) are picked up.
  function buttons() {
    return Array.from(document.querySelectorAll('.music-toggle'));
  }

  function setHidden(el, hidden) {
    if (!el) return;
    if (hidden) {
      el.setAttribute('hidden', '');
    } else {
      el.removeAttribute('hidden');
    }
  }

  function syncUi() {
    const playing = !audio.paused;
    buttons().forEach((button) => {
      const playIcon = button.querySelector('.music-toggle__icon--play');
      const pauseIcon = button.querySelector('.music-toggle__icon--pause');
      const playLabel = button.dataset.playLabel || 'Play music';
      const pauseLabel = button.dataset.pauseLabel || 'Pause music';
      button.setAttribute('aria-pressed', String(playing));
      button.setAttribute('aria-label', playing ? pauseLabel : playLabel);
      button.classList.toggle('is-playing', playing);
      setHidden(playIcon, playing);
      setHidden(pauseIcon, !playing);
    });
  }

  function toggle() {
    if (audio.paused) {
      if (!audio.src && audio.dataset.src) {
        audio.src = audio.dataset.src;
      }
      audio.play().catch(() => syncUi());
    } else {
      audio.pause();
    }
  }

  function onError() {
    buttons().forEach((button) => {
      button.hidden = true;
    });
  }

  audio.addEventListener('play', syncUi);
  audio.addEventListener('pause', syncUi);
  audio.addEventListener('error', onError);
  audio.addEventListener('ended', syncUi);

  // Delegated so every music toggle works, including ones swapped in by the SPA
  // router after initial load.
  document.addEventListener('click', function (event) {
    if (!event.target.closest('.music-toggle')) return;
    toggle();
  });

  // Re-sync all toggles after SPA navigation: a music toggle swapped back in
  // (e.g. returning to the Me hub) must show the current play/pause state,
  // not the default "ready to play" icon.
  document.addEventListener('page:load', syncUi);

  syncUi();
}());
